export default {
  section: 'Punto de venta',
  title: 'Configuración del punto de venta',
  select: 'Puntos de venta',
  description: 'Para poder llevar acabo la vinculación con Wantsoft necesitamos que introduzcas el id que se te proporcionó junto con la contraseña. Ambas las proporciona Wantsoft, posteriormente guarda el formulario y se terminará la vinculación.',
  pointSales: {
    wansoft: {
      wansoftId: 'Id de Wansoft',
      wansoftPwd: 'Contraseña de Wansoft'
    }
  },
  btn: {
    save: 'Guardar datos del punto de venta'
  }
}
